var _style, _g, _path, _path2, _polygon, _g2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 883.6 390.9",
    style: {
      enableBackground: "new 0 0 883.6 390.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#666464;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:#0091FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,470.8v53.8H0v-53.8H6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,524.6v-40.2h6.1v5.3c3.1-4.6,8.2-6.4,12.6-6.4c6.3,0,10,3.3,11.5,6.4c1.5,3.1,1.8,6.1,1.8,12.2v22.7h-6.1 v-22.7c0-6.3,0-13-8.7-13c-1.9,0-11.1,0.5-11.1,13v22.7H18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,472.8h6.1v11.5h12.2v5.7H67.6V513c0,3.8,0,7.1,6.2,7.1c0.9,0,2.5-0.1,5.5-0.5v5.6 c-1.4,0.2-3.6,0.5-6.3,0.5c-11.1,0-11.4-6.7-11.4-12.7V490h-5.2v-5.7h5.2V472.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.1,506.7c0.3,7.4,4.5,13.4,14.4,13.4c6.6,0,10.3-2.2,12.6-3.5v6.6c-1.8,0.8-6.1,2.6-12.6,2.6 c-16.2,0-20.4-12.1-20.4-20.9c0-13,8.1-21.4,18.4-21.4c4.9,0,12.4,2,15.9,10.9c1.8,4.5,1.9,9.8,1.9,12.6H90.1z M114.1,501.2 c-0.8-9.8-7.4-12.3-11.9-12.3c-6.6,0-11.6,5-12.1,12.3H114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,524.6v-40.2h6.1v5.3c4.3-6.6,10.4-6.4,13-6.4v5.7c-8.7-0.1-13,4.1-13,13v22.7H128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.9,486.6c1.6-0.9,6.1-3.3,13-3.3c1.8,0,9.1,0,13.5,5c2.5,2.9,2.7,6.1,2.7,10.2V517c0,4.3,0.8,6.1,1.5,7.6 h-6.4c-0.5-1-1-2-1.1-5c-3.8,4.1-8.8,6.1-14.4,6.1c-8.7,0-12.7-5.5-12.7-11.7c0-12,12.2-13.4,19.2-14.3c5.7-0.7,7.7-0.9,7.7-4.2 c0-4.6-5-6.6-10.1-6.6c-6.2,0-10.5,2.6-12.4,3.8L156.9,486.6z M180.1,503.5c-2,0.8-2.7,1-8.5,1.6c-5.9,0.8-12.5,1.9-12.5,8.6 c0,3.9,2.6,6.5,7.1,6.5c4.6,0,11-2.7,13.9-8.3V503.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.1,522.9c-1.5,0.8-5.1,2.7-11.8,2.7c-13.9,0-20.9-9.3-20.9-20.9c0-13,8.9-21.5,20.7-21.5 c4.5,0,8.3,1.1,12.1,3.5l-1.7,5.6c-1.2-1-4.3-3.5-10.1-3.5c-8,0-14.8,5.1-14.8,15.6c0,9,5.1,15.6,14.9,15.6 c6.2,0,10.2-2.6,11.7-3.5V522.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.5,472.8h6.1v11.5h12.2v5.7h-12.2V513c0,3.8,0,7.1,6.2,7.1c0.9,0,2.5-0.1,5.5-0.5v5.6 c-1.4,0.2-3.6,0.5-6.3,0.5c-11.1,0-11.4-6.7-11.4-12.7V490h-5.2v-5.7h5.2V472.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.4,478.3h-7.2v-7.5h7.2V478.3z M267.9,524.6h-6.2v-40.2h6.2V524.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.8,484.4h6.6l-13,40.2h-8.1l-13-40.2h6.6l10.5,34L301.8,484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.1,506.7c0.3,7.4,4.5,13.4,14.4,13.4c6.6,0,10.3-2.2,12.6-3.5v6.6c-1.8,0.8-6.1,2.6-12.6,2.6 c-16.2,0-20.4-12.1-20.4-20.9c0-13,8.1-21.4,18.4-21.4c4.9,0,12.4,2,15.9,10.9c1.8,4.5,1.9,9.8,1.9,12.6H318.1z M342.1,501.2 c-0.8-9.8-7.4-12.3-11.9-12.3c-6.6,0-11.6,5-12.1,12.3H342.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.2,470.8c6.2,0,9.9,0.8,13.2,3.4c4.1,3.2,5.5,8.3,5.5,12.6c0,15.9-14.6,15.9-19.9,15.9h-6.5v21.8h-6.4 v-53.8H393.2z M392.8,496.9c4.4,0,12.8,0,12.8-10c0-10.2-8.1-10.2-12.8-10.2h-7.2v20.2H392.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,486.6c1.6-0.9,6.1-3.3,13-3.3c1.8,0,9.1,0,13.5,5c2.5,2.9,2.7,6.1,2.7,10.2V517c0,4.3,0.8,6.1,1.5,7.6 h-6.4c-0.5-1-1-2-1.1-5c-3.8,4.1-8.8,6.1-14.4,6.1c-8.7,0-12.7-5.5-12.7-11.7c0-12,12.2-13.4,19.2-14.3c5.7-0.7,7.7-0.9,7.7-4.2 c0-4.6-5-6.6-10.1-6.6c-6.2,0-10.5,2.6-12.4,3.8L422.1,486.6z M445.3,503.5c-2,0.8-2.7,1-8.5,1.6c-5.9,0.8-12.5,1.9-12.5,8.6 c0,3.9,2.6,6.5,7.1,6.5c4.6,0,11-2.7,13.9-8.3V503.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462,524.6v-40.2h6.1v5.3c4.3-6.6,10.4-6.4,13-6.4v5.7c-8.7-0.1-13,4.1-13,13v22.7H462z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.6,500.3l17.1-15.9h8.1l-18.4,16.9l20.6,23.3h-8l-19.5-22.7v22.7h-6.1v-56.3h6.1V500.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M535.5,478.3h-7.2v-7.5h7.2V478.3z M535,524.6h-6.2v-40.2h6.2V524.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.9,524.6v-40.2h6.1v5.3c3.1-4.6,8.2-6.4,12.6-6.4c6.3,0,10,3.3,11.5,6.4c1.5,3.1,1.8,6.1,1.8,12.2v22.7 h-6.1v-22.7c0-6.3,0-13-8.7-13c-1.9,0-11.1,0.5-11.1,13v22.7H545.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.6,489.3c-1.2-0.1-3.3-0.3-5.8,1.1c0.3,0.7,1.6,3.1,1.6,6.8c0,10.3-9.6,13.1-15.2,13.1 c-2.1,0-3.6-0.3-4.4-0.5c-2.7,0.7-4.8,2.6-4.8,4.2c0,1.4,1.2,2,1.8,2.3c1.7,0.5,4.3,0.7,10.5,1c3.8,0.2,15.5,0.8,15.5,12.2 c0,13.2-15.7,13.2-18.5,13.2c-13.2,0-18.2-6.2-18.2-12.5c0-6.3,4.6-9.4,6-10.3c-1.4-0.8-3.3-2.1-3.3-5c0-3.2,2.7-5.8,5.3-7.4 c-4.7-3.2-5.8-7.8-5.8-11c0-7.8,6.3-13.3,15.6-13.3c2,0,5.9,0.3,9.5,2.5c2.3-1.7,4.8-2.5,7.6-2.5c1.4,0,1.8,0.1,2.5,0.3V489.3z  M600.8,522.2c-9.7,0-9.7,6.8-9.7,7.7c0,6.5,7.8,7.3,12.1,7.3c7.6,0,12.4-2.8,12.4-7.4C615.7,523.9,610.9,522.2,600.8,522.2z  M593.3,497c0,4.4,3.6,7.9,9.4,7.9c5.5,0,9.4-3.2,9.4-8.1c0-4.3-3-8.1-9.2-8.1C596.3,488.7,593.3,493,593.3,497z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M676.8,479c-3.1-2.3-6.3-3.4-10.2-3.4c-6,0-10.4,3.5-10.4,9.1c0,5.7,4.5,7.5,10,9.4 c7.1,2.3,15.2,5.3,15.2,15.8c0,8.7-6.7,15.9-18.8,15.9c-5.6,0-10.4-1.3-15-4.3l1.9-5.8c3.9,2.8,8,4.2,12.8,4.2 c6.2,0,12.6-2.9,12.6-9.6c0-5.3-4-8.1-7.8-9.3c-10.7-3.8-17.3-6-17.3-15.9c0-9.2,7.2-15.2,16.6-15.2c4.4,0,8.2,1.1,12,3.2 L676.8,479z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M700.2,521.6l-14.8-37.3h6.6l11.5,29.2l11.5-29.2h6.6L698,542.7h-6.1L700.2,521.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M749.1,491.4c-1.9-1.1-4.5-2.5-8.9-2.5c-3.8,0-8.2,1.4-8.2,5.7c0,4.1,2.3,4.8,9.8,7.2 c4.5,1.4,11.5,3.6,11.5,11.7c0,9.2-9.1,12.1-16.2,12.1c-1.2,0-7.2,0-13-3.2l2-5.3c2.3,1.2,5.7,2.9,11.1,2.9c1.4,0,10,0,10-6.5 c0-4.5-4.6-5.8-8.5-7c-6.3-1.8-12.6-3.8-12.6-11.7c0-7.4,6.5-11.6,14.2-11.6c5.3,0,9,1.8,10.6,2.5L749.1,491.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M762.5,472.8h6.1v11.5h12.2v5.7h-12.2V513c0,3.8,0,7.1,6.2,7.1c0.9,0,2.5-0.1,5.5-0.5v5.6 c-1.4,0.2-3.6,0.5-6.3,0.5c-11.1,0-11.4-6.7-11.4-12.7V490h-5.2v-5.7h5.2V472.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M791.1,506.7c0.3,7.4,4.5,13.4,14.4,13.4c6.6,0,10.3-2.2,12.6-3.5v6.6c-1.8,0.8-6.1,2.6-12.6,2.6 c-16.2,0-20.4-12.1-20.4-20.9c0-13,8.1-21.4,18.4-21.4c4.9,0,12.4,2,15.9,10.9c1.8,4.5,1.9,9.8,1.9,12.6H791.1z M815.1,501.2 c-0.8-9.8-7.4-12.3-11.9-12.3c-6.6,0-11.6,5-12.1,12.3H815.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M853.4,524.6v-23.2c0-6-0.6-12.5-7.4-12.5c-4,0-10.4,2.6-10.4,12.1v23.5h-6.1v-40.2h6.1v5.4 c1.1-1.6,4.4-6.5,11.5-6.5c1.5,0,8.3,0,11.3,7.5c2.5-4.4,6.4-7.5,12.6-7.5c3.1,0,9.6,1.1,11.7,8.6c0.7,2.4,0.8,4.6,0.8,8.9v23.8 h-6.1v-23.1c0-5,0-12.5-7.6-12.5c-2.2,0-10.4,0.7-10.4,13.4v22.2H853.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397,212.4h89.6v44.4H397V212.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.5,256.7v128.5h-50.6V68.8h57.3c28.1,0,49.3,1.8,63.6,5.5C658.3,78,671,85,682,95.2 c19.2,17.8,28.9,40.2,28.9,67.2c0,29-10.3,51.9-30.8,68.9c-20.6,16.9-48.3,25.4-83.2,25.4H573.5z M573.5,212.4h18.9 c46.5,0,69.7-16.9,69.7-50.6c0-32.6-24-49-71.9-49h-16.7V212.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "362.9,272 362.9,385.2 314,385.2 314,259.5  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.4,256.8 83.4,212.4 83.4,192.5 83.4,175 83.4,68.8 32.8,68.8 32.8,385.2 83.4,385.2 83.4,344.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "228.1,68.8 228.1,175 228.1,192.5 228.1,212.4 228.1,256.8 228.1,344.5 228.1,385.2 278.6,385.2  278.6,68.8  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.8416,
    y1: 193.7948,
    x2: 487.9543,
    y2: 193.7948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242961"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#0091FF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.4,385.2H32.8c0-38.4,30.7-117.4,95.7-165.3c36.6-26.9,97.1-53.3,184.9-36.9v-0.7 c0-63.4,36.2-172.6,171.7-179.8l2.7,48.9c-118.5,6.3-124.5,110.1-124.5,130.9v64.5l-32-9.2c-68.6-19.7-126.8-12.4-172.9,21.5 C101.7,300.9,83.4,367.1,83.4,385.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M837.3,288.2c-9-8.9-26.4-18.6-52.3-29.1c-18.8-7.5-28.2-15.1-28.2-22.7c0-4.4,1.6-8,4.8-10.8 c3.2-2.8,7-4.2,11.5-4.2c9.4,0,17.3,6.1,23.7,18.4l40.4-20.3c-13.2-26.4-33.3-39.5-60.4-39.5c-18.4,0-34,5.7-46.9,17 c-12.6,11.3-18.9,25.7-18.9,43c0,13.1,3.7,23.8,11.1,32.2c5.8,6.6,15.8,13.1,30,19.7c5.1,2.3,10.1,4.6,15,6.8 c4.9,2.2,9.8,4.4,14.8,6.8c12.7,7.1,19.1,14.8,19.1,23c0,14.2-8.2,21.3-24.8,21.3h-72.1l0,0h-37.7v41.2h109.8v0 c20.3-0.2,37.7-6.3,52.1-18.4c15.1-13,22.6-29.1,22.6-48.4C850.8,309.1,846.3,297.1,837.3,288.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.270d05a549900f044d349d62c2c9e616.svg";
export { ForwardRef as ReactComponent };